import React from 'react';
import { Button, Colors, Display, Sizes } from 'Views/Components/Button/Button';

interface EditActionsProps {
	saving: boolean;
	onSave: () => void;
	onCancel: () => void;
	/** Full-width buttons for the mobile save bar; compact for the desktop header. */
	fullWidth?: boolean;
	/** Defaults to the account pages' wording; the password page overrides both. */
	saveLabel?: string;
	savingLabel?: string;
	/** "Discard" where the tab stages edits rather than entering an edit mode it can leave. */
	cancelLabel?: string;
	cancelId?: string;
	saveId?: string;
}

/** The Cancel / Save pair for an account edit session — shared by both account pages. */
export function EditActions({
	saving,
	onSave,
	onCancel,
	fullWidth = false,
	saveLabel = 'Save changes',
	savingLabel = 'Saving...',
	cancelLabel = 'Cancel',
	cancelId = 'update_profile_cancel',
	saveId = 'update_profile_save',
}: EditActionsProps) {
	return (
		<>
			<Button
				newStyles
				display={Display.Outline}
				colors={Colors.Secondary}
				sizes={fullWidth ? Sizes.Medium : Sizes.Small}
				className={fullWidth ? 'flex-1' : undefined}
				buttonProps={{ id: cancelId }}
				onClick={onCancel}
			>
				{cancelLabel}
			</Button>
			<Button
				newStyles
				display={Display.Solid}
				colors={Colors.Primary}
				sizes={fullWidth ? Sizes.Medium : Sizes.Small}
				className={fullWidth ? 'flex-1' : undefined}
				buttonProps={{ id: saveId }}
				onClick={onSave}
				disabled={saving}
			>
				{saving ? savingLabel : saveLabel}
			</Button>
		</>
	);
}

/**
 * Thumb-reachable Save/Cancel bar fixed to the bottom of the viewport — the mobile counterpart
 * of the desktop header actions.
 */
export function MobileSaveBar(props: Omit<EditActionsProps, 'fullWidth'>) {
	return (
		<div
			className={
				'fixed inset-x-0 bottom-0 z-30 flex gap-3 border-t border-gray-200 ' +
				'bg-white p-4 pb-[max(1rem,env(safe-area-inset-bottom))] ' +
				'shadow-[0_-4px_12px_rgba(0,0,0,0.08)]'
			}
		>
			<EditActions {...props} fullWidth />
		</div>
	);
}
